import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box17_ReferringProvider: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        17. NAME OF REFERRING PROVIDER OR OTHER SOURCE
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Controller
          name="referringProviderName"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField field={field} fieldState={fieldState} size="small" sx={{ flex: '2 1 50%' }} />
          )}
        />
        <Controller
          name="referringProviderIdQualifier"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="a. ID Qual"
              disabled
              sx={{ flex: '1 1 25%' }}
            />
          )}
        />
        <Controller
          name="referringProviderNPI"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="b. NPI"
              sx={{ flex: '1 1 25%' }}
            />
          )}
        />
      </Box>
    </>
  );
};